import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import useHasRight from "../../../../authorization/hooks/useHasRight";

import tabHasNotification from "../utils/tabHasNotification";

export default function useProductionMenuOptions({ production, offers, alerts }) {
	const { t } = useTranslation();
	const location = useLocation();
	const hasRight = useHasRight();

	const { pathname } = location;

	const alertArray = Object.values(alerts);

	const isAdmin = hasRight("productions.admin");
	const isManager = hasRight("productions.manage");
	const isSubcontractor = hasRight("subcontractor", false);

	const infoAlerts = isManager ? alertArray?.filter((m) => m.tab === "info").length : 0;
	const articlesAlerts = isManager ? alertArray?.filter((m) => m.tab === "articles").length : 0;
	const audiobookAlerts = isManager ? alertArray?.filter((m) => m.tab === "audiobook").length : 0;

	const readerOffersNotifications = tabHasNotification("readers", { offers });
	const teamOffersNotifications = tabHasNotification("team", { offers });

	return [
		{
			to: `/production/${production.id}`,
			text: t("overview", "Overview"),
			label: infoAlerts || undefined,
			active: pathname.endsWith(production.id),
		},
		{
			to: "articles",
			text: t("articles", "Articles"),
			label: articlesAlerts || undefined,
			active: pathname.includes("articles"),
			hidden: !isManager || (!isAdmin && isSubcontractor) || !!production.work,
		},
		{
			to: "artifacts",
			text: t("delivery", "Delivery"),
			active: pathname.includes("artifacts"),
			hidden: !hasRight("productions.artifacts") || !production.work,
		},
		{
			to: "audiobook",
			text: t("production", "Production"),
			label: audiobookAlerts || undefined,
			active: pathname.includes("audiobook"),
			hidden:
				!(typeof production.isbn === "string" || production.deliveryParts || production.work) ||
				// production.productionType || // Assigns string value that resolves false in check
				(typeof production.productionType === "undefined" && production.status === "draft") ||
				production.productionType === "external",
		},
		{
			to: "readers",
			text: t("narrators", "Narrators"),
			label: readerOffersNotifications || undefined,
			active: pathname.includes("readers"),
			hidden: !isManager || (!isAdmin && isSubcontractor) || production.productionType === "external",
		},
		{
			to: "team",
			text: t("teamAndOffers", "Team & Offers"),
			label: teamOffersNotifications || undefined,
			active: pathname.endsWith(`${production.id}/team`),
			hidden: !hasRight("productions.finalize") || production.status === "offer",
		},
		{
			to: "discussions",
			text: t("discussion", "Discussion"),
			active: pathname.endsWith(`${production.id}/discussions`),
			hidden: !hasRight("discussions.manage") || production.useNewDiscussion,
		},
		{
			to: "finance",
			text: t("finance", "Finance"),
			active: pathname.includes("finance"),
			hidden: !hasRight("finance.editProductionPrices") || production.status === "offer",
		},
		{
			to: "settings",
			text: t("settings", "Settings"),
			active: pathname.includes("settings"),
			hidden: !hasRight("productions.settings.level1"),
		},
	];
}
